import React from "react"
import styled from "styled-components"
import { DANGER, SUCCESS, PRIMARY } from "const"
import { UpdateIcon } from "client/components"

type VariantType = typeof DANGER | typeof SUCCESS | typeof PRIMARY

const getColor = (variant: VariantType, theme: any) => {
    switch (variant) {
        case DANGER:
            return theme.dangerButtonColor
        case SUCCESS:
            return theme.successButtonColor
        case PRIMARY:
        default:
            return theme.primaryButtonColor
    }
}

export const Button = styled.div<{
    variant?: VariantType
    disabled?: boolean
    row?: boolean
    after?: boolean
    uppercase?: boolean
}>`
    display: flex;
    position: relative;
    align-items: center;
    height: 38px;
    width: fit-content;
    min-width: 80px;
    justify-content: center;
    line-height: 20px;
    padding: ${(props) => (props.after ? "0 30px 0 15px" : "0 15px")};
    float: ${(props) => (props.row ? "left" : "unset")};
    margin: ${(props) => (props.row ? "0 10px 8px 0" : "0")};
    border-radius: 2px;
    white-space: nowrap;
    font-size: ${(props) => props.theme.fontSizes.md}px;
    font-family: ${(props) => props.theme.openSans};
    font-weight: 600;
    text-transform: ${(props) => (props.uppercase === false ? "inherit" : "uppercase")};
    user-select: none;
    opacity: ${(props) => (props.disabled ? 0.55 : 1)};
    pointer-events: ${(props) => (props.disabled ? "none" : "all")};
    background: ${(props) => {
        switch (props.variant) {
            case DANGER:
                return props.theme.dangerButtonBackground
            case SUCCESS:
                return props.theme.successButtonBackground
            case PRIMARY:
            default:
                return props.theme.primaryButtonBackground
        }
    }};
    color: ${(props) => getColor(props.variant, props.theme)};

    & > i {
        font-size: 24px;
    }

    & > input[type="file"] {
        position: absolute;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
    }

    &::after {
        content: "";
        display: ${(props) => (props.after ? "block" : "none")};
        border-top: 4px solid ${(props) => getColor(props.variant, props.theme)};
        border-right: 4px solid transparent;
        border-bottom: 0;
        border-left: 4px solid transparent;
        position: absolute;
        right: 10px;
        top: 18px;
    }
`

export const LinkButton = styled.span<{
    disabled?: boolean
}>`
    width: fit-content;
    white-space: nowrap;
    cursor: pointer;
    font-size: ${(props) => props.theme.fontSizes.md}px;
    opacity: ${(props) => (props.disabled ? 0.55 : 1)};
    pointer-events: ${(props) => (props.disabled ? "none" : "all")};
    color: ${(props) => props.theme.linkButtonColor};
    border-bottom: 1px dashed ${(props) => props.theme.linkButtonColor};
    transition: ${(props) => props.theme.defaultTransition};

    &:hover {
        color: ${(props) => props.theme.linkButtonHoverColor};
        border-color: ${(props) => props.theme.linkButtonHoverColor};
    }
`

export const TextButton = styled.span<{
    disabled?: boolean
}>`
    white-space: nowrap;
    cursor: pointer;
    padding: 4px 0;
    font-weight: 600;
    font-family: ${(props) => props.theme.openSans};
    font-size: ${(props) => props.theme.fontSizes.md}px;
    opacity: ${(props) => (props.disabled ? 0.55 : 1)};
    pointer-events: ${(props) => (props.disabled ? "none" : "all")};
    color: ${(props) => props.theme.textButtonColor};
`

const UpdateButtonWrapper = styled.div`
    width: 22px;
    height: 22px;
    line-height: 22px;
    border-radius: 50%;
    display: inline-block;
    cursor: pointer;
    background: ${(props) => props.theme.updateButtonBackground};
    color: ${(props) => props.theme.updateButtonColor};
`
export const UpdateButton = (props: React.HTMLAttributes<HTMLDivElement>) => (
    <UpdateButtonWrapper {...props}>
        <UpdateIcon />
    </UpdateButtonWrapper>
)
